<template>
    <div id="invoiceDetail">
        <AppBreadCrumb
            :paths="[{ title: $t('billing.invoiceManagement'), path: '/billing' }, { title: 'Fatura Detay' }]"
            :select="true"
        />
        <div class="invoice-detail-content">
            <div class="invoice">
                <div class="invoice-head" style="margin-bottom: 20px">
                    <div class="row-item">
                        <div class="column-item">
                            <div class="title">{{ $t("billing.site") }}</div>
                            <div class="content">{{ siteName }}</div>
                        </div>
                        <div class="column-item">
                            <div class="title">{{ $t("billing.period") }}</div>
                            <div class="content">{{ formatedDetails.period }}</div>
                        </div>
                        <div class="column-item" style="width: 30%">
                            <div class="title">{{ $t("billing.billStatus") }}</div>
                            <div class="content">{{ invoice.paid ? $t("billing.paid") : $t("billing.unPaid") }}</div>
                        </div>
                    </div>
                    <div :class="invoice.isManuel && invoice.description ? 'row-item-space-between' : 'row-item-end'">
                        <div class="column-item" v-if="invoice.description">
                            <div class="title">{{ $t("message.description") }}</div>
                            <div class="content">{{ invoice.description }}</div>
                        </div>
                        <div class="column-item">
                            <div class="title">{{ $t("billing.totalPrice") }}</div>
                            <div class="content">{{ ~~(invoice.price || 0) }}₺</div>
                        </div>
                    </div>
                </div>

                <div class="invoice-head" style="margin-bottom: 20px" v-if="formatedDetails.result.length > 0">
                    <div class="row-item">
                        <div class="column-item">
                            <div class="title">{{ $t("instagram.detail") }}</div>
                        </div>
                    </div>
                </div>
                <div class="details" v-if="formatedDetails.result.length > 0">
                    <div class="detail-content" v-for="planGroup of formatedDetails.result">
                        <div class="head">
                            <div class="title">
                                {{ planGroup.title }}
                                <span class="ml-1" v-if="planGroup.isFeature"> (Özellik) </span>
                            </div>
                            <div class="price">{{ ~~(planGroup.price || 0) }}₺</div>
                        </div>
                        <div class="content">
                            <div class="detail-content-child" v-for="plan of planGroup.actions">
                                <div class="head">
                                    <div class="title">
                                        <span>{{ plan.title }}</span> ({{ plan._period }}) - {{ plan.period }}
                                    </div>
                                    <div class="price">{{ plan.price }}₺</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import _ from "lodash";

const { getInvoiceById } = require("../../../api/billing");

export default {
    name: "InvoiceDetail",
    components: { AppBreadCrumb },
    data() {
        return {
            siteName: "",
            invoice: {},
            formatedDetails: {
                isPaid: false,
                totalPrice: 0,
                price: 0,
                kdvPrice: 0,
                period: "",
                result: [],
            },
        };
    },
    watch: {},
    methods: {
        getFreeAgentCount(features) {
            const feature = features.find((feature) => feature.type === "agent");
            return feature && feature.freeAgentCount;
        },
        formatDetails() {
            const bill = this.invoice;
            const isMonthly = ["monthly", "none"].includes(bill.type);
            const startDateFormat = isMonthly ? "MMM DD" : "MMM DD, YYYY";
            const startDate = moment(bill.createdDate).format(startDateFormat);
            const endDate = moment(bill.createdDate).endOf("month").format("MMM DD, YYYY");
            const period = isMonthly ? `${startDate} - ${endDate}` : startDate;
            const timeBuckets = Object.keys(_.get(bill, "details.timeBuckets", {})).reduce((acc, planType) => {
                acc = acc.concat(
                    bill.details.timeBuckets[planType].map((details) => Object.assign({}, details, { type: planType }))
                );
                return acc;
            }, []);
            const price = +(bill.price / (1 + bill.vatRate)).toFixed(2);
            const kdvPrice = +(bill.price - bill.price / (1 + bill.vatRate)).toFixed(2);
            const walletDetail = {
                "wallet-deposit": {
                    1: {
                        price: bill.price,
                        title: "Deposit Money to Wallet",
                        period: period,
                        _period: "Whatsapp",
                    },
                },
            };
            const periods = {
                monthly: this.$t("billing.monthly"),
                "monthly-3": this.$t("billing.threeMonthly"),
                "monthly-6": this.$t("billing.sixMonthly"),
                annual: this.$t("billing.yearly"),
                "annual-2": this.$t("billing.twoYearly"),
                forever: this.$t("billing.forever"),
            };

            const details =
                bill.type === "wallet-deposit"
                    ? walletDetail
                    : timeBuckets.reduce((acc, timeBucket, currentIndex) => {
                          if (!acc[timeBucket.type]) acc[timeBucket.type] = {};
                          const plan = bill.details.planActions[timeBucket.planActionId].target;
                          const planAction = bill.details.planActions[timeBucket.planActionId].data;
                          const quantity =
                              _.get(planAction, "details.agentCount") ||
                              _.get(planAction, "details.whatsappChannel") ||
                              _.get(planAction, "details.instagramChannel") ||
                              _.get(planAction, "details.messengerChannel");

                          const startDate = moment(planAction.createdDate).format("MMM DD YYYY");
                          const endDate =
                              _.get(timeBuckets[currentIndex + 1], "planActionId") !== planAction._id &&
                              moment(timeBucket.date).format("MMM DD YYYY");

                          const isFeature = plan.type === "feature";
                          const price = _.get(
                              acc[timeBucket.type][timeBucket.planActionId],
                              "price",
                              bill.type !== "monthly" ? bill.price : 0
                          );
                          acc[timeBucket.type][timeBucket.planActionId] = {
                              _id: planAction._id,
                              type: plan.type,
                              price: +(
                                  price +
                                  (_.get(timeBucket, "details.acceptPrice", 0) ||
                                      _.get(timeBucket, "details.dailyPrice", 0))
                              ).toFixed(2),
                              title: `${plan.title} ${plan.altTitle}` + (!!quantity ? ` (${quantity} Adet)` : ""),
                              period: startDate + (endDate ? ` - ${endDate}` : ""),
                              _period: periods[planAction.period],
                              isFeature,
                          };
                          return acc;
                      }, {});

            const result = Object.keys(details).reduce((acc, title) => {
                const price = Object.values(details[title]).reduce((acc, detail) => acc + detail.price, 0);
                acc.push({
                    price: ~~price,
                    isFeature: _.get(Object.values(details[title]), "[0].isFeature"),
                    title: title
                        .split("-")
                        .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                        .join(" "),
                    actions: Object.values(details[title]).map((action) => {
                        return Object.assign({}, action, {
                            price: ~~action.price,
                        });
                    }),
                });
                return acc;
            }, []);

            this.formatedDetails = {
                isPaid: bill.paid,
                totalPrice: bill.price,
                price,
                kdvPrice,
                period,
                result,
            };
        },
        isFeature(planGroups) {
            return Object.values(planGroups.details)[0]?.plan?.type === "feature";
        },
    },
    mounted() {
        getInvoiceById(this.$route.params.id).then((data) => {
            this.invoice = data.invoice;
            this.siteName = data.siteName;
            this.formatDetails();
        });
    },
};
</script>
<style lang="scss" scoped>
#invoiceDetail {
    .invoice-detail-content {
        background: white;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .invoice {
        width: 85vw;
        height: 100vh;
        border: 1px solid #c7d0d7;
        margin-top: 10px;
    }

    .top-head {
        display: flex;
        align-items: top;
        justify-content: space-between;
        margin-top: 10px;

        img {
            width: 200px;
            height: 80px;
        }

        .info {
            display: flex;
            flex-direction: column;
            align-items: end;
            font-weight: bold;
            font-size: 14px;
        }
    }

    .invoice-head {
        padding: 20px 30px;
        background: #f1f4f7;

        .row-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &-end {
                display: flex;
                align-items: center;
                justify-content: flex-end !important;
                margin-top: 20px;
            }
            &-space-between {
                display: flex;
                align-items: center;
                justify-content: space-between !important;
                margin-top: 20px;
            }
        }

        .title {
            font-size: 16px;
        }

        .content {
            font-size: 16px;
            font-weight: 500;
        }
    }

    .details {
        display: flex;
        flex-direction: column;
        justify-content: start;
        padding: 30px;
        padding-top: 0;

        .detail-content {
            user-select: none;
            margin-top: 4px;

            &-child {
                .head {
                    background: none !important;
                    color: black !important;
                    border: none !important;

                    .title {
                        font-weight: normal !important;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        span {
                            font-weight: 400 !important;
                        }
                    }

                    .price {
                        font-weight: lighter !important;
                        font-size: 12px;
                    }
                }
            }

            .head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: black;
                background: #f1f4f7;
                padding: 4px 12px;

                .title {
                    font-weight: bold;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: black;
                        font-weight: bold;
                        margin-right: 10px;
                    }
                }

                .price {
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
